import { render } from "./PlanCuentas.vue?vue&type=template&id=4b9bc3f6&scoped=true"
import script from "./PlanCuentas.vue?vue&type=script&lang=js"
export * from "./PlanCuentas.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./PlanCuentas.vue?vue&type=style&index=1&id=4b9bc3f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9bc3f6"]])

export default __exports__